
import { Link } from "react-router-dom";
import Footer from "../components/footer";

export default function Pricing () {
    return (
        <div class="w-full sm:w-1/3">
            <div class="w-full mt-8 flex flex-row justify-around">
               <div class="text-4xl w-5/12">
                   <p>horsey</p>
               </div>
               <Link class="w-3/12 rounded pt-1 h-8 bg-blue-700" to="/beforeSignUp">
               <div class="w-full text-white text-center font-light">
                   <p>Sign In</p>
               </div>
               </Link>
           </div>
            <div class="text-2xl p-8">
                Pricing
            </div>
            <div className="px-8 mb-32">If you use the app for more than 5 minutes a day, you will be charged ₹5 for that day.</div>
           <Footer/>
           </div>
    )
}